import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestRoutes } from '../_config/rest-routes.config';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = 'dco-token';
const USERNAME_KEY = 'dco-username';

@Injectable({
  providedIn: 'root'
})
export class PwRecoverService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  localResponse

  constructor(private http: HttpClient) { }

  async PwRecovermethod(user: any): Promise<any> {
    let urlLogin: string = `${environment.urlWS}${RestRoutes.PW_RECOVER}`;
    return await fetch(urlLogin, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      },
      body: JSON.stringify(user)
    });
  }

  public getToken(): string {
    const token = window.localStorage.getItem(TOKEN_KEY);
    // console.log(token)
    return token;
  }

}
